import { Button as RawButton, ButtonProps } from 'baseui/button';
import { InputProps, Input as RawInput } from 'baseui/input';
import stylesColors from 'common/styles/styles.colors';

import RichTextInput, { RichTextFieldProps } from './editor/rich-text-input';
import CheckBoxInput, { CheckBoxInputProps } from './fields/checkbox';
import DateTimePickerInput, {
  DateTimePickerInputProps,
} from './fields/date-time-picker';
import PhoneNumberInput, { PhoneNumberInputProps } from './fields/phone-number';
import PinCodeInput, { PinCodeInputProps } from './fields/pin-code';
import RadioGroupInput, { RadioGroupInputProps } from './fields/radio';
import SelectInput, { SelectInputProps } from './fields/select';
import SubmitField, { SubmitProps } from './fields/submit-field';
import SwitchField, { SwitchFieldProps } from './fields/switch-field';
import TagInput, { TagInputProps } from './fields/tag';
import TextAreaInput, { TextAreaInputProps } from './fields/text-area-input';
import TextField, { TextInputProps } from './fields/text-field';
import TextFieldNumber, {
  StyledNumberFormat,
  TextFieldNumberProps,
} from './fields/text-field-number';
import TimePickerInput, {
  TimePickerInputProps,
} from './fields/time-picker-input';
import {
  MultipleFilePicker,
  MultipleFilePickerProps,
  SingleFilePicker,
  SingleFilePickerProps,
} from './file-picker';

export { FormState, default as Form } from './form';
export { default as ReadOnlyText } from './read-only-text';
export { default as TableComponent } from './table-component/table-component';
export function Input(
  props:
    | TextInputProps
    | TextFieldNumberProps
    | PhoneNumberInputProps
    | SelectInputProps
    | DateTimePickerInputProps
    | CheckBoxInputProps
    | TextAreaInputProps
    | SingleFilePickerProps
    | MultipleFilePickerProps
    | SubmitProps
    | PinCodeInputProps
    | TimePickerInputProps
    | TagInputProps
    | SwitchFieldProps
    | RadioGroupInputProps
    | RichTextFieldProps,
) {
  switch (props.type) {
    case 'switch':
      return <SwitchField {...props} />;
    case 'phone':
      return <PhoneNumberInput {...props} />;
    case 'number':
      return <TextFieldNumber {...props} />;
    case 'text-area':
      return <TextAreaInput {...props} />;
    case 'select':
      return <SelectInput {...props} />;
    case 'date-time':
      return <DateTimePickerInput {...props} />;
    case 'time':
      return <TimePickerInput {...props} />;
    case 'check-box':
      return <CheckBoxInput {...props} />;
    case 'file':
      return <SingleFilePicker {...props} />;
    case 'files':
      return <MultipleFilePicker {...props} />;
    case 'pin-code':
      return <PinCodeInput {...props} />;
    case 'submit':
      return <SubmitField {...props} />;
    case 'radio-group':
      return <RadioGroupInput {...props} />;
    case 'tag':
      return <TagInput {...props} />;
    case 'editor':
      return <RichTextInput {...props} />;
    default:
      return <TextField {...props} />;
  }
}

export function Button(props: ButtonProps) {
  const rootStyles = {
    ...styles.button,
    ...((props?.overrides?.Root as any)?.style
      ? (props?.overrides?.Root as any)?.style
      : {}),
  };

  return (
    <RawButton
      {...props}
      overrides={{
        ...props.overrides,
        Root: {
          ...props.overrides?.Root,
          style: { ...rootStyles },
        },
      }}
      type={props.type || 'button'}
      kind="secondary"
    />
  );
}

export function NumberInput(props: InputProps) {
  return (
    <StyledNumberFormat
      {...props}
      thousandSeparator
      clearable
      customInput={RawInput}
    />
  );
}

const styles = {
  button: {
    fontSize: '14px',
    fontWeight: 'bold',
    paddingTop: '4px',
    paddingBottom: '4px',
    paddingRight: '16px',
    paddingLeft: '16px',
    minHeight: '36px',
    borderRadius: '77px',
    backgroundColor: 'transparent',
    borderColor: stylesColors.primaryDefault,
    color: stylesColors.primaryDefault,
    borderWidth: '1px',
    borderStyle: 'solid',
    ':hover': {
      backgroundColor: stylesColors.primaryLightest,
    },
  },
};
